<!--
    组织机构单选选下拉框。需要暴露什么接口再扩展
    api:
        orgsChange 值变化后的回调函数，返回id数组
-->

<template>
    <div class="tree-container-pop">
        <el-input
            class="search"
            v-model="name"
            size="small"
            placeholder="查询组织机构"
            :validate-event="false"
            prefix-icon="el-icon-search"
            @input="onInput"
            clearable>
        </el-input>

        <el-tree
            class="org-tree"
            ref="orgTree"
            :data="orgData"
            :props="defaultProps"
            node-key="id"
            default-expand-all
            :expand-on-click-node="false"
            highlight-current
            @node-click="nodeClick">
            <span
                slot-scope="{ node, data }"
                :class="'id_'+data.id"
            >{{ node.label }}</span>
        </el-tree>
    </div>
</template>

<script>
    import api from '@/api';
    import {mapGetters} from 'vuex';

    export default {
        props: {
            isTreePop: {
                default: false
            },
            defaultCheck:{
                type:String
            }
        },

        data() {
            return {
                name: '',
                orgData: '',
                defaultProps: {
                    children: 'children',
                    label: 'name',
                    id:'id'
                },
            }
        },

        created() {
            this.$store.dispatch('getOrgTree').then(data => {
                if (!data.length) {
                    this.$emit('noData');
                } else {
                    this.$emit('dataLoaded');
                }

                this.orgData = data
            });
        },

        watch: {
            defaultCheck: {
                handler(v) {
                    this.$nextTick(() => {
                        $('.el-tree-node').removeClass('is-current')
                        if(this.defaultCheck){
                            $('.id_'+this.defaultCheck).parent().parent().addClass('is-current')
                        }
                    })
                },
                immediate: true
            },
            orgTree(v) {
                this.orgData = this.orgTree
            }
        },

        computed: {
            ...mapGetters([
                'orgTree',
            ]),
        },

        methods: {
            onInput(v) {
                if (!v.trim()) {
                    this.orgData = this.orgTree
                    return
                }

                let result = []

                const filter = (arr) => {
                    arr.forEach(ele => {
                        if (ele.name.indexOf(v) > -1) {
                            result.push({
                                id: ele.id,
                                name: ele.name,
                            })
                        }

                        if (ele.children && ele.children.length) {
                            filter(ele.children)
                        }
                    });

                    return arr;
                }

                filter(this.orgTree)
                this.orgData = result
            },

            nodeClick(data){
                //$('.el-tree-node').removeClass('is-current')
                api.getOrganizationDetail(data.id).then(res=>{
                    this.$emit('getTreeNodeData',res.package);
                });
            },
        },
    }
</script>

<style lang="scss">
    @import '../style/const.scss';

    .tree-container{

        .el-tree-node__content:hover{
            background-color: transparent;
        }
        .el-tree-node:focus > .el-tree-node__content {
            //background-color: transparent;
        }
        .el-tree-node > .el-tree-node__content.red{
            background-color: #f5f7fa;
        }
    }
    .tree-container-pop{
        @include scrollbar(#aaa);
        width: 300px;

        .search {
            margin-bottom: 5px;
        }

        .org-tree {
            margin-right: -12px;
            max-height: 400px;
            overflow: auto;
        }

        .el-tree-node__content:hover{
            background-color: transparent;
        }
        .el-tree-node:focus > .el-tree-node__content {
            //background-color: transparent;
        }
        .el-tree-node > .el-tree-node__content.pink{
            background-color: #f5f7fa;
        }
    }
</style>
